var ReifendirektCaptchaAddOnJs = (function ($) {
    var callBackFunctions = {};
    var recaptchaIds = {};
    var renderedElements = {};
    var sitekey = null;
    var badge = null;
    var invisibleCaptchaEnabled = false;

    var registerCallBackFunction = function(captchaName, callBackFunction) {
        callBackFunctions[captchaName] = callBackFunction;
    };

    var renderRecaptcha = function(captchaName){
        if(typeof grecaptcha === 'undefined'){
            return;
        }
        var element = document.getElementById(captchaName);
        if(element === null){
            return;
        }
        // grecaptcha.render throws "reCAPTCHA has already been rendered in this element" on a second call
        if(renderedElements[captchaName] === element){
            return;
        }
        // a placeholder re-inserted from saved markup still holds the old widget, grecaptcha needs it empty
        $(element).empty();
        var id = grecaptcha.render(element, {
            'sitekey' : sitekey,
            'size' : 'invisible',
            'badge' : badge,
            'callback' : callBackFunctions[captchaName]
            });
        recaptchaIds[captchaName] = id;
        renderedElements[captchaName] = element;
    };

    var executeRecaptcha = function(captchaName) {
        if(typeof grecaptcha !== 'undefined'){
            grecaptcha.execute(recaptchaIds[captchaName]);
        }
    };
    var getRecaptchaResponse = function(captchaName) {
        if(typeof grecaptcha === 'undefined'){
            return '';
        }
        return grecaptcha.getResponse(recaptchaIds[captchaName]);
    };

    var recaptchaReset = function (captchaName) {
        if(typeof grecaptcha === 'undefined'){
            return '';
        }

        return grecaptcha.reset(recaptchaIds[captchaName]);
    }

    var addSubmitButtonEventListener = function(captchaSelector, captchaName) {
        var submitButton= $(captchaSelector).closest("form").find(':submit');
        if(typeof submitButton !== 'undefined') {
           $(submitButton).off('click.' + captchaName).on('click.' + captchaName, function (e) {
               e.preventDefault();
               recaptchaReset(captchaName)
               grecaptcha.execute(recaptchaIds[captchaName]);
           });
        };
    };

    var init = function(captchaSiteKey, dataBadge) {
        sitekey = captchaSiteKey;
        badge = dataBadge;
        invisibleCaptchaEnabled = true;
    };

    var isInvisibleCaptchaEnabled = function(){
        return invisibleCaptchaEnabled;
    }

    return {
        registerCallBackFunction : registerCallBackFunction,
        executeRecaptcha : executeRecaptcha,
        init : init,
        renderRecaptcha : renderRecaptcha,
        addSubmitButtonEventListener : addSubmitButtonEventListener,
        getRecaptchaResponse : getRecaptchaResponse,
        isInvisibleCaptchaEnabled : isInvisibleCaptchaEnabled,
        recaptchaReset : recaptchaReset
    };

})(jQuery);
